"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = require("../../atoms/Button/Button");
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
exports.LinkCard = function (_a) {
    var image = _a.image, text = _a.text, onClick = _a.onClick, _b = _a.buttonText, buttonText = _b === void 0 ? "Link" : _b, _c = _a.buttonVariant, buttonVariant = _c === void 0 ? "primary" : _c, id = _a.id, disabled = _a.disabled, caption = _a.caption;
    var cardId, buttonId, iconJsx, button;
    if (id) {
        cardId = id + "-link-card";
        buttonId = cardId + "-button-" + buttonVariant;
    }
    if (image) {
        iconJsx = (react_1.default.createElement(theme_ui_1.Box, { "data-testid": "link-card-image-wrapper", sx: {
                mr: "10px",
                width: "60px"
            } }, image));
    }
    if (onClick) {
        var buttonTitle = text + " - " + buttonText;
        button = (react_1.default.createElement(Button_1.Button, { id: buttonId, title: buttonTitle, onClick: onClick, variant: buttonVariant, disabled: disabled }, buttonText));
    }
    return (react_1.default.createElement(theme_ui_1.Grid
    // TODO: remove either id or data-testid based on outcome of guild meeting
    , { 
        // TODO: remove either id or data-testid based on outcome of guild meeting
        id: cardId, "data-testid": cardId, columns: [1, 2], sx: {
            mb: "10px",
            py: "10px",
            borderBottom: "1px solid" + theme_1.theme.colors.text,
            rowGap: ["2rem", "0rem"]
        } },
        react_1.default.createElement(theme_ui_1.Flex, { sx: {
                alignItems: "center",
                justifyContent: ["center", "flex-start"]
            } },
            iconJsx,
            react_1.default.createElement(theme_ui_1.Text, null, text)),
        react_1.default.createElement(theme_ui_1.Flex, { sx: {
                alignItems: "center",
                justifyContent: ["center", "flex-end"]
            } }, button),
        caption && (react_1.default.createElement(theme_ui_1.Flex, { sx: {
                gridColumn: "1 / -1",
                justifyContent: ["center", "flex-start"],
                paddingTop: ["0px", "4px"]
            } },
            react_1.default.createElement(theme_ui_1.Text, { variant: "caption" }, caption)))));
};
